import { Theme } from '~/ui/styling/Theme'

export const panelBorderRadius = (theme: Theme) => theme.guide.web.panel.borderRadius(theme.guide.web.panel.minHeight)
